import { onFontsReady } from "../utils/onFontsReady";
import { initFontsGate } from "../utils/initFontsGate";

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
initFontsGate("Manrope", [400, 700]);

function initReviewsText(wrapper) {
	if (!wrapper || wrapper.dataset.gsapReviewsInited) return;
	wrapper.dataset.gsapReviewsInited = "1";

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

	const title = wrapper.querySelector(".webvibe-reviews-title");
	const desc = wrapper.querySelector(".webvibe-reviews-description");
	const slider = wrapper.querySelector(".webvibe-reviews-slider");

	if (!title && !desc) return;

	if (title) gsap.set(title, { opacity: 0, y: 14 });
	if (desc) gsap.set(desc, { opacity: 0, y: 10 });
	if (slider) gsap.set(slider, { opacity: 0 });

	const tl = gsap.timeline({
		defaults: { ease: "power2.out" },
		scrollTrigger: {
			trigger: wrapper,
			start: "top 85%",
			once: true,
			invalidateOnRefresh: true,
		},
	});

	if (title) {
		tl.to(title, {
			opacity: 1,
			y: 0,
			duration: 0.55,
			clearProps: "transform,opacity",
		});
	}

	if (desc) {
		tl.to(
			desc,
			{
				opacity: 1,
				y: 0,
				duration: 0.45,
				clearProps: "transform,opacity",
			},
			"-=0.25"
		);
	}

	if (slider) {
		tl.to(
			slider,
			{
				opacity: 1,
				duration: 0.6,
				clearProps: "opacity",
			},
			"-=0.15" // чуть перекрывается с текстом
		);
	}

}

onFontsReady(() => {
	document.querySelectorAll(".wv-gsap-reviews").forEach(initReviewsText);
	ScrollTrigger.refresh();
});


document.addEventListener('DOMContentLoaded', () => {
	const reviewsSlider = document.querySelector('.webvibe-reviews-slider');

	if (reviewsSlider) {
		const reviews = new Swiper('.webvibe-reviews-slider', {

			loop: true,
			slidesPerView: 1,
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			spaceBetween: 30,
			navigation: {
			nextEl: ".webvibe-reviews-button-next",
			prevEl: ".webvibe-reviews-button-prev",
		},
			speed: 1000,
			grabCursor: true,
			mousewheelControl: true,
			breakpoints: {
				
			}
		});
	}
});
